import { create } from 'zustand'

interface TickerState {
  tickerMap: Record<string, WsTickerItem>
  lastTickerAt: number
  lastTickerAtMap: Record<string, number>
  mergeTickers: (incoming: Record<string, WsTickerItem>) => void
  retainSymbols: (symbols: string[]) => void
  reset: () => void
}

export const useTickerStore = create<TickerState>((set) => ({
  tickerMap: {},
  lastTickerAt: 0,
  lastTickerAtMap: {},
  mergeTickers: (incoming) =>
    set((state) => {
      const now = Date.now()
      const lastTickerAtMap = { ...state.lastTickerAtMap }

      for (const [symbol, item] of Object.entries(incoming)) {
        lastTickerAtMap[symbol] = now
        if (item.sym) lastTickerAtMap[item.sym] = now
      }

      return {
        tickerMap: { ...state.tickerMap, ...incoming },
        lastTickerAt: now,
        lastTickerAtMap,
      }
    }),
  retainSymbols: (symbols) =>
    set((state) => {
      const allowed = new Set(symbols)
      const tickerMap: Record<string, WsTickerItem> = {}
      const lastTickerAtMap: Record<string, number> = {}
      let changed = false

      for (const [symbol, item] of Object.entries(state.tickerMap)) {
        if (allowed.has(symbol) || allowed.has(item.sym)) {
          tickerMap[symbol] = item
          if (state.lastTickerAtMap[symbol]) {
            lastTickerAtMap[symbol] = state.lastTickerAtMap[symbol]
          }
          if (item.sym && state.lastTickerAtMap[item.sym]) {
            lastTickerAtMap[item.sym] = state.lastTickerAtMap[item.sym]
          }
        } else {
          changed = true
        }
      }

      if (Object.keys(lastTickerAtMap).length !== Object.keys(state.lastTickerAtMap).length) {
        changed = true
      }

      return changed ? { tickerMap, lastTickerAtMap } : state
    }),
  reset: () => set({ tickerMap: {}, lastTickerAt: 0, lastTickerAtMap: {} }),
}))
